<template >
  <div style="width: 100%; height: 100%; text-align: center;">    
    
    <div v-if="this.data.image1 == null" style="font-size: 20px; color: white; padding-top: 10px;">{{ this.data.enterprise_name }}</div>
    <img v-if="this.data.image1 != null" :src="'data:image;base64,' + this.data.image1" class="responsive-barcode"/>    
    <br/>
    <img :src="'data:image;base64,' + this.data.image" class="responsive-barcode"/>
    <br/>
    <div v-html="this.data.html" class="responsive-barcode"></div>

  </div>   
</template>

<script lang="ts">

export default {
  name: 'Department',
  components: {   
  },
  data: function () {
    return {
      data: null     
    };
  },
  created() {   
  
    this.data = this.$store.state.barcode;
    console.log(this.data);
  },
  mounted() {

  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>

html, body, #app {
  height: 100%;
  margin: 0;
  background-image: url('/img/avatars/web_1024x768.png');
  background-size: cover;
}

/* 預設情況（大螢幕） */
.responsive-barcode {
  width: 600px;
  height: auto; /* 確保高度依比例縮放，不會變形 */
   margin: 0 auto;
}

/* 當螢幕寬度小於 768px 時（平板與手機） */
@media (max-width: 768px) {
  .responsive-barcode {
    padding-right: 10px;
    padding-left: 10px;
    width: 100%;
  }
}


/* 預設情況（大螢幕） */
.responsive-textbox {
  width: 600px;
  height: auto; /* 確保高度依比例縮放，不會變形 */
  border: 1px solid #ccc; 
  padding: 8px; 
  border-radius: 4px;

}

/* 當螢幕寬度小於 768px 時（平板與手機） */
@media (max-width: 768px) {
  .responsive-textbox {
    padding-right: 10px;
    padding-left: 10px;
    width: 100%;
    border: 1px solid #ccc; 
    padding: 8px; 
    border-radius: 4px;
  }
}


</style>

<style lang="scss" src="../../scss/base.scss"></style>
